import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom";

const token = localStorage.getItem('authToken');

class EditContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textInput: null, // For optional image upload
      category: "", // New field for category
      content: "", // New field for content
      submissionStatus: null,
      currentImageUrl: null, 
      submeet: false,
      errors: [],
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
      id: null,
      isLoading: true,
      imageUrl: "", // Added state for storing image URL
    };
  }

  async componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      await this.fetchData(id);
    } else {
      console.error("No match params found.");
    }
  }

  fetchData = async (id) => {
    console.log("Fetching data for ID:", id);
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/getbyid/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include token in the headers
        }
      });
      if (response) {
        console.log(response.data);
        this.setState({
          category: response.data?.category || "", // Load category from API
          content: response.data?.name || "", // Load content from API
          imageUrl: response.data?.image || "", // Set image URL
          currentImageUrl: `https://uma-classees.blr1.digitaloceanspaces.com/${response.data?.image}`, // Set image URL for preview
          isLoading: false,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ isLoading: false });
    }
  };

  handleChange = (e) => {
    const files = Array.from(e.target.files);
    const errors = [];

    files.forEach((file) => {
      if (file.size > this.state.maxSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
      } else {
        this.setState({
          textInput: file,
          currentImageUrl: URL.createObjectURL(file), // Update current image URL to show the new image
        });
      }
    });

    this.setState({ errors });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { id } = this.props.match.params;
    this.setState({ submeet: true });

    const { textInput, category, content } = this.state;

    // Validation
    if (!category || !content) {
      return;
    }

    try {
      const formData = new FormData();
      formData.append("category", category);
      formData.append("name", content);

      if (textInput) {
        formData.append("image", textInput); // Append image only if user selects one
      }

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        }
      };

      const response = await axios.put(`https://samaj.aasmo.in/api/admin/update/${id}`, formData, config);

      if (response.status === 200) { 
        this.setState({ submissionStatus: 'success' });
        setTimeout(() => {
          this.props.history.push("/list-content");
        }, 2000);
      }

      console.log(response, "==>res");
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { textInput, category, content, currentImageUrl, submeet, submissionStatus, isLoading } = this.state;
    const isCategoryValid = category.trim().length > 0;
    const isContentValid = content.trim().length > 0;

    if (isLoading) {
      return <div>Loading...</div>;
    }

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Edit Content</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>
              {/* Optional Image Upload */}
              <div className="form-group">
                <label>Image (Optional)</label>
                {currentImageUrl && (
                  <div>
                    <img src={currentImageUrl} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
                  </div>
                )}
                <input
                  type="file"
                  className="form-control"
                  name="textInput"
                  onChange={this.handleChange}
                />
              </div>

              {/* Category Text Input */}
              <div className="form-group">
                <label>Category</label>
                <input
                  className={`form-control ${!isCategoryValid && submeet && "parsley-error"}`}
                  value={category}
                  name="category"
                  required
                  type="text"
                  onChange={(e) => {
                    this.setState({ category: e.target.value });
                  }}
                />
                {!isCategoryValid && submeet && (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">Category is required.</li>
                  </ul>
                )}
              </div>

              {/* Content Text Input */}
              <div className="form-group">
                <label>Content</label>
                <textarea
                  className={`form-control ${!isContentValid && submeet && "parsley-error"}`}
                  value={content}
                  name="content"
                  required
                  onChange={(e) => {
                    this.setState({ content: e.target.value });
                  }}
                />
                {!isContentValid && submeet && (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">Content is required.</li>
                  </ul>
                )}
              </div>

              {submissionStatus === "success" && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}

              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, { notifyGeneralInfo })(withRouter(EditContent));
